import {Exclude, instanceToPlain} from "class-transformer";
import {ReHelper} from "@/classes/common/ReHelper";

export default class WaitlistItem {
    id: number;
    show_id: number;
    vendor_id: number | null;
    show_name: string;
    location: string;
    start_date: string;
    end_date: string;
    request: string;
    sort_order: number;
    item_color: string;
    @Exclude()
    created: string;

    @Exclude()
    bookings: number[];
    @Exclude()
    canceled_bookings: number[];

    @Exclude()
    vendor_name: string | null;

    constructor(id: number, show_id: number, vendor_id: number | null, show_name: string, location: string, start_date: string, end_date: string,
                request: string, created: string, sort_order: number = 0, item_color: string = '', vendor_name: string | null = null, bookings: number[] = [], canceled_bookings: number[] = []) {
        this.id = id;
        this.show_id = show_id;
        this.vendor_id = vendor_id;
        this.show_name = show_name;
        this.location = location;
        this.start_date = start_date;
        this.end_date = end_date;
        this.request = request;
        this.created = created;
        this.sort_order = sort_order;
        this.item_color = item_color;

        this.vendor_name = vendor_name;
        this.bookings = bookings;
        this.canceled_bookings = canceled_bookings;
    }

    static from(o: any): WaitlistItem {
        return new WaitlistItem(
            o.id,
            o.show_id,
            o.vendor_id,
            o.show_name,
            o.location,
            o.start_date,
            o.end_date,
            o.request,
            o.created,
            o.sort_order,
            o.item_color,
            o.vendor_name,
            o.bookings,
            o.canceled_bookings,
        )
    }

    copyTo(w: WaitlistItem) {
        w.show_id = this.show_id;
        w.vendor_id = this.vendor_id;
        w.show_name = this.show_name;
        w.location = this.location;
        w.start_date = this.start_date;
        w.end_date = this.end_date;
        w.request = this.request;
        w.created = this.created;
        w.vendor_name = this.vendor_name;
        w.sort_order = this.sort_order;
        w.item_color = this.item_color;
    }

    prepare_for_save() {
        return instanceToPlain(this);
    }

    clone(): WaitlistItem {
        return WaitlistItem.from(this);
    }

    static default(): WaitlistItem {
        return new WaitlistItem(0, 0, null, "", "", "", "", "", ReHelper.now);
    }

    get name() {
        return this.request;
    }

    get short_description() {
        return this.request;
    }
}
